import BaseService from '@/services/base_service';
import { clearPhone } from '@/services/string';
import Axios from 'axios';

export default class CarrierService extends BaseService {

  async list(params) {
    try {
      return await axios.get('/operadora', params);
    } catch (e) {
      throw e;
    }
  }
  async get(id) {
    try {
      return await axios.get('/operadora/' + id);
    } catch (e) {
      throw e;
    }
  }
  async create(model) {

    try {
      return await axios.post('operadora/', model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async update(model, id) {
    try {
      return await axios.put('/operadora/' + id, model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async delete(id) {
    try {
      return await axios.delete('/operadora/' + id);
    } catch (e) {
      throw e;
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/carrier.js